<script setup lang="ts">
import type { ConcreteComponent, ComputedOptions, MethodOptions } from 'vue';

const props = defineProps<{
  href?: string;
  active?: boolean;
  component?: | ConcreteComponent<{}, any, any, ComputedOptions, MethodOptions> | string;
}>();

const finalComponent = computed(() => {
  return props.component || 'a';
});
</script>

<template>
  <Component
    :is="finalComponent"
    :class="[
      'relative text-16 flex items-center justify-center p-5 text-neutral-60 cursor-pointer font-bold text-nowrap',
      active ? 'm-button-navigation--active !text-neutral-100' : ''
    ]"
  >
    <slot />
  </Component>
</template>

<style lang="scss">
.m-button-navigation--active {
  @screen lg {
    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 80%;
      height: 0.75rem;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 2rem 2rem 0 0;
      background-color: var(--palette-blue-60);
    }
  }
}
</style>

